import { Box, Flex } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react';
import BottomNavigation from '../components/BottomNavigation'
import AppFooter from './AppFooter'
import AppHeader from './AppHeader'

const GA_TRACKING_ID = 'G-M7JRK5GEJY';
const AppLayout = () => {
	useEffect(() => {
		if (!window.gtag) {
		  const script1 = document.createElement('script');
		  script1.async = true;
		  script1.src = `https://www.googletagmanager.com/gtag/js?id=G-${GA_TRACKING_ID}`;
		  document.head.appendChild(script1);
	  
		  const script2 = document.createElement('script');
		  script2.innerHTML = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', ${GA_TRACKING_ID});
		  `;
		  document.head.appendChild(script2);
		}
	  }, []);

	return (
		<Flex minH={'100vh'} direction={'column'} pt={'70px'} bg={'white'}>
			<AppHeader />
			<Box minH={'calc(100vh - 110px)'}>
				<Outlet />
			</Box>
			<AppFooter />
			<BottomNavigation />
		</Flex>
	)
}

export default AppLayout
